// Central Multi-Geo Configuration for Dinosaur World Festival 2026

export const GEOS = {
  qa: {
    id: 'qa',
    name: 'Qatar',
    currencyCode: 'QAR',
    currencySymbol: { ar: 'ر.ق', en: 'QAR' },
    phonePrefix: '+974',
    phonePlaceholder: '33123456',
    seatPrefix: 'QA',
    defaultLang: 'ar',
    supportedLangs: ['ar', 'en'],
    merchantName: 'Dino World Qatar',
    domainName: 'dinoworld-qatar.com',
    venue: {
      ar: 'مركز قطر الوطني للمؤتمرات (QNCC) - القاعة 5',
      en: 'Qatar National Convention Centre (QNCC) - Hall 5'
    },
    datesText: {
      ar: 'مفتوح يومياً: 16 سبتمبر – 31 أكتوبر 2026 | تذكرة مرنة صالحة طوال الفترة (09:00 ص – 09:00 م)',
      en: 'Open Daily: 16 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      ar: '31 أكتوبر 2026',
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { arDay: 'تذكرة مفتوحة • أي يوم', enDay: 'OPEN PASS • ANY DATE', arDate: 'صالحة لأي يوم حتى 31 أكتوبر 2026', enDate: 'Valid Any Day until 31 Oct 2026', arTag: 'الأكثر طلباً • مرونة 100%', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { arDay: 'تذكرة أيام الأسبوع (أحد - خميس)', enDay: 'WEEKDAY PASS (SUN–THU)', arDate: 'صالحة لأي يوم عمل حتى 31 أكتوبر', enDate: 'Any Weekday until 31 Oct 2026', arTag: 'أوقات هادئة', enTag: 'Calm Visit' },
      'weekend-pass': { arDay: 'تذكرة عطلة نهاية الأسبوع (جمعة - سبت)', enDay: 'WEEKEND PASS (FRI–SAT)', arDate: 'صالحة لأي عطلة نهاية أسبوع', enDate: 'Any Weekend until 31 Oct 2026', arTag: 'أجواء حماسية', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      ar: './images/dino_world_qatar_banner_ar.jpg',
      en: './images/dino_world_qatar_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 153.00, price: 76.50 },
          kid: { standardPrice: 117.00, price: 58.50 }
        }
      }
    }
  },

  om: {
    id: 'om',
    name: 'Oman',
    currencyCode: 'OMR',
    currencySymbol: { ar: 'ر.ع.', en: 'OMR' },
    phonePrefix: '+968',
    phonePlaceholder: '91234567',
    seatPrefix: 'OM',
    defaultLang: 'ar',
    supportedLangs: ['ar', 'en'],
    merchantName: 'Dino World Oman',
    domainName: 'dinoworld-oman.com',
    venue: {
      ar: 'مركز عُمان للمؤتمرات والمعارض (OCEC) - مسقط (القاعة 3 و4)',
      en: 'Oman Convention & Exhibition Centre (OCEC) - Muscat (Halls 3 & 4)'
    },
    datesText: {
      ar: 'مفتوح يومياً: 17 سبتمبر – 31 أكتوبر 2026 | تذكرة مرنة صالحة طوال الفترة (09:00 ص – 09:00 م)',
      en: 'Open Daily: 17 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      ar: '31 أكتوبر 2026',
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { arDay: 'تذكرة مفتوحة • أي يوم', enDay: 'OPEN PASS • ANY DATE', arDate: 'صالحة لأي يوم حتى 31 أكتوبر 2026', enDate: 'Valid Any Day until 31 Oct 2026', arTag: 'الأكثر طلباً • مرونة 100%', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { arDay: 'تذكرة أيام الأسبوع (أحد - خميس)', enDay: 'WEEKDAY PASS (SUN–THU)', arDate: 'صالحة لأي يوم عمل حتى 31 أكتوبر', enDate: 'Any Weekday until 31 Oct 2026', arTag: 'أوقات هادئة', enTag: 'Calm Visit' },
      'weekend-pass': { arDay: 'تذكرة عطلة نهاية الأسبوع (جمعة - سبت)', enDay: 'WEEKEND PASS (FRI–SAT)', arDate: 'صالحة لأي عطلة نهاية أسبوع', enDate: 'Any Weekend until 31 Oct 2026', arTag: 'أجواء حماسية', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      ar: './images/dino_world_oman_banner_ar.jpg',
      en: './images/dino_world_oman_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 16.00, price: 8.00 },
          kid: { standardPrice: 12.00, price: 6.00 }
        }
      }
    }
  },

  kw: {
    id: 'kw',
    name: 'Kuwait',
    currencyCode: 'KWD',
    currencySymbol: { ar: 'د.ك.', en: 'KWD' },
    phonePrefix: '+965',
    phonePlaceholder: '91234567',
    seatPrefix: 'KW',
    defaultLang: 'ar',
    supportedLangs: ['ar', 'en'],
    merchantName: 'Dino World Kuwait',
    domainName: 'dinoworld-kuwait.com',
    venue: {
      ar: 'أرض المعارض الدولية (مشرف) - صالة 5 و6، الكويت',
      en: 'Kuwait International Fair (KIF Mishref) - Halls 5 & 6'
    },
    datesText: {
      ar: 'مفتوح يومياً: 17 سبتمبر – 31 أكتوبر 2026 | تذكرة مرنة صالحة طوال الفترة (09:00 ص – 09:00 م)',
      en: 'Open Daily: 17 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      ar: '31 أكتوبر 2026',
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { arDay: 'تذكرة مفتوحة • أي يوم', enDay: 'OPEN PASS • ANY DATE', arDate: 'صالحة لأي يوم حتى 31 أكتوبر 2026', enDate: 'Valid Any Day until 31 Oct 2026', arTag: 'الأكثر طلباً • مرونة 100%', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { arDay: 'تذكرة أيام الأسبوع (أحد - خميس)', enDay: 'WEEKDAY PASS (SUN–THU)', arDate: 'صالحة لأي يوم عمل حتى 31 أكتوبر', enDate: 'Any Weekday until 31 Oct 2026', arTag: 'أوقات هادئة', enTag: 'Calm Visit' },
      'weekend-pass': { arDay: 'تذكرة عطلة نهاية الأسبوع (جمعة - سبت)', enDay: 'WEEKEND PASS (FRI–SAT)', arDate: 'صالحة لأي عطلة نهاية أسبوع', enDate: 'Any Weekend until 31 Oct 2026', arTag: 'أجواء حماسية', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      ar: './images/dino_world_kuwait_banner_ar.jpg',
      en: './images/dino_world_kuwait_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 14.00, price: 7.00 },
          kid: { standardPrice: 10.00, price: 5.00 }
        }
      }
    }
  },

  hk: {
    id: 'hk',
    name: 'Hong Kong',
    currencyCode: 'HKD',
    currencySymbol: { zh: 'HK$', en: 'HK$' },
    phonePrefix: '+852',
    phonePlaceholder: '91234567',
    seatPrefix: 'HK',
    defaultLang: 'zh',
    supportedLangs: ['zh', 'en'],
    merchantName: 'Dino World Hong Kong',
    domainName: 'dinoworld-hongkong.com',
    venue: {
      zh: '亞洲國際博覽館 (AsiaWorld-Expo) - 2號展館',
      en: 'AsiaWorld-Expo - Hall 2, Hong Kong'
    },
    datesText: {
      zh: '每日開放：2026年9月18日 – 11月1日 | 全期有效 (09:00 – 21:00)',
      en: 'Open Daily: 18 September – 1 November 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      zh: '2026年11月1日',
      en: '1 November 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { zhDay: '全期通用門票 (任意日期)', enDay: 'OPEN PASS • ANY DATE', zhDate: '2026年11月1日前任意單日有效', enDate: 'Valid Any Day until 1 Nov 2026', zhTag: '最受歡迎 • 100%靈活', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { zhDay: '平日門票 (星期一至五)', enDay: 'WEEKDAY PASS (MON–FRI)', zhDate: '11月1日前任意平日有效', enDate: 'Any Weekday until 1 Nov 2026', zhTag: '舒適避峰', enTag: 'Calm Visit' },
      'weekend-pass': { zhDay: '週末門票 (星期六及日)', enDay: 'WEEKEND PASS (SAT–SUN)', zhDate: '11月1日前任意週末有效', enDate: 'Any Weekend until 1 Nov 2026', zhTag: '週末黃金場', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      zh: './images/dino_world_hongkong_banner_zh.jpg',
      en: './images/dino_world_hongkong_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 276.00, price: 138.00 },
          kid: { standardPrice: 196.00, price: 98.00 }
        }
      }
    }
  },

  sg: {
    id: 'sg',
    name: 'Singapore',
    currencyCode: 'SGD',
    currencySymbol: { en: 'S$' },
    phonePrefix: '+65',
    phonePlaceholder: '81234567',
    seatPrefix: 'SG',
    defaultLang: 'en',
    supportedLangs: ['en'],
    merchantName: 'Dino World Singapore',
    domainName: 'sgdynoworld.live',
    venue: {
      en: 'Singapore Expo (Halls 3 & 4), 1 Expo Drive, Singapore'
    },
    datesText: {
      en: 'Open Daily: 10 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { enDay: 'OPEN PASS • ANY DATE', enDate: 'Valid Any Day until 31 Oct 2026', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { enDay: 'WEEKDAY PASS (MON–FRI)', enDate: 'Any Weekday until 31 Oct 2026', enTag: 'Calm Visit • Less Crowded' },
      'weekend-pass': { enDay: 'WEEKEND PASS (SAT–SUN)', enDate: 'Any Weekend until 31 Oct 2026', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      en: './images/dino_world_singapore_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 36.00, price: 18.00 },
          kid: { standardPrice: 28.00, price: 14.00 }
        }
      }
    }
  },

  my: {
    id: 'my',
    name: 'Malaysia',
    currencyCode: 'MYR',
    currencySymbol: { en: 'RM' },
    phonePrefix: '+60',
    phonePlaceholder: '123456789',
    seatPrefix: 'MY',
    defaultLang: 'en',
    supportedLangs: ['en'],
    merchantName: 'Dino World Malaysia',
    domainName: 'mydynoworld.live',
    venue: {
      en: 'Malaysia International Trade and Exhibition Centre (MITEC) Kuala Lumpur (Halls 1 & 2)'
    },
    datesText: {
      en: 'Open Daily: 10 September – 31 October 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      en: '31 October 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { enDay: 'OPEN PASS • ANY DATE', enDate: 'Valid Any Day until 31 Oct 2026', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { enDay: 'WEEKDAY PASS (MON–FRI)', enDate: 'Any Weekday until 31 Oct 2026', enTag: 'Calm Visit • Less Crowded' },
      'weekend-pass': { enDay: 'WEEKEND PASS (SAT–SUN)', enDate: 'Any Weekend until 31 Oct 2026', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      en: './images/dino_world_malaysia_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 70.00, price: 35.00 },
          kid: { standardPrice: 56.00, price: 28.00 }
        }
      }
    }
  },
  lv: {
    id: 'lv',
    name: 'Latvia',
    currencyCode: 'EUR',
    currencySymbol: { lv: '€', en: '€' },
    phonePrefix: '+371',
    phonePlaceholder: '21234567',
    seatPrefix: 'LV',
    defaultLang: 'lv',
    supportedLangs: ['lv', 'en'],
    merchantName: 'Dino World Latvia',
    domainName: 'dynoworldlv.live',
    venue: {
      lv: 'Starptautiskais izstāžu centrs Ķīpsala (Halle 1 un 2), Ķīpsalas iela 8, Rīga',
      en: 'Ķīpsala International Exhibition Centre (Halls 1 & 2), Ķīpsalas iela 8, Riga'
    },
    datesText: {
      lv: 'Atvērts katru dienu: 25. septembris – 8. novembris 2026 | Elastīgā biļete (09:00 – 21:00)',
      en: 'Open Daily: 25 September – 8 November 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      lv: '2026. gada 8. novembris',
      en: '8 November 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { lvDay: 'ATVĒRTĀ BIĻETE • JEBKURĀ DIENĀ', enDay: 'OPEN PASS • ANY DATE', lvDate: 'Derīga jebkurā dienā līdz 8. novembrim', enDate: 'Valid Any Day until 8 Nov 2026', lvTag: 'Pieprasītākā • 100% elastība', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { lvDay: 'DARBA DIENU BIĻETE (PIRMD–PIEKT)', enDay: 'WEEKDAY PASS (MON–FRI)', lvDate: 'Jebkurā darba dienā līdz 8. novembrim', enDate: 'Any Weekday until 8 Nov 2026', lvTag: 'Mierīgs apmeklējums', enTag: 'Calm Visit' },
      'weekend-pass': { lvDay: 'BRĪVDIENU BIĻETE (SEST–SVĒT)', enDay: 'WEEKEND PASS (SAT–SUN)', lvDate: 'Jebkurā nedēļas nogalē līdz 8. novembrim', enDate: 'Any Weekend until 8 Nov 2026', lvTag: 'Nedēļas nogales pasākums', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      lv: './images/dino_world_latvia_banner_lv.jpg',
      en: './images/dino_world_latvia_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 24.00, price: 12.00 },
          kid: { standardPrice: 18.00, price: 9.00 }
        }
      }
    }
  },

  pl: {
    id: 'pl',
    name: 'Poland',
    currencyCode: 'PLN',
    currencySymbol: { pl: 'zł', en: 'PLN' },
    phonePrefix: '+48',
    phonePlaceholder: '512345678',
    seatPrefix: 'PL',
    defaultLang: 'pl',
    supportedLangs: ['pl', 'en'],
    merchantName: 'Dino World Poland',
    domainName: 'dynoworldpl.live',
    venue: {
      pl: 'Centrum EXPO XXI Warszawa (Hala 1 i 2), ul. Prądzyńskiego 12/14, Warszawa',
      en: 'EXPO XXI Warsaw (Halls 1 & 2), 12/14 Prądzyńskiego St, Warsaw'
    },
    datesText: {
      pl: 'Otwarte codziennie: 26 września – 8 listopada 2026 | Bilet otwarty (09:00 – 21:00)',
      en: 'Open Daily: 26 September – 8 November 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      pl: '8 listopada 2026',
      en: '8 November 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { plDay: 'BILET OTWARTY • DOWOLNY DZIEŃ', enDay: 'OPEN PASS • ANY DATE', plDate: 'Ważny w dowolny dzień do 8 listopada 2026', enDate: 'Valid Any Day until 8 Nov 2026', plTag: 'Najchętniej wybierany • 100% elastyczności', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { plDay: 'BILET W DNI POWSZEDNIE (PON–PT)', enDay: 'WEEKDAY PASS (MON–FRI)', plDate: 'Dowolny dzień powszedni do 8 listopada', enDate: 'Any Weekday until 8 Nov 2026', plTag: 'Spokojniejsze zwiedzanie', enTag: 'Calm Visit' },
      'weekend-pass': { plDay: 'BILET WEEKENDOWY (SOB–ND)', enDay: 'WEEKEND PASS (SAT–SUN)', plDate: 'Dowolny weekend do 8 listopada', enDate: 'Any Weekend until 8 Nov 2026', plTag: 'Weekendowe emocje', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      pl: './images/dino_world_poland_banner_pl.jpg',
      en: './images/dino_world_poland_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 110.00, price: 55.00 },
          kid: { standardPrice: 80.00, price: 40.00 }
        }
      }
    }
  },

  ch: {
    id: 'ch',
    name: 'Switzerland',
    currencyCode: 'CHF',
    currencySymbol: { de: 'CHF', en: 'CHF' },
    phonePrefix: '+41',
    phonePlaceholder: '791234567',
    seatPrefix: 'CH',
    defaultLang: 'de',
    supportedLangs: ['de', 'en'],
    merchantName: 'Dino World Switzerland',
    domainName: 'dynoworldch.live',
    venue: {
      de: 'Messe Zürich (Halle 1 & 2), Wallisellenstrasse 49, 8050 Zürich',
      en: 'Messe Zurich (Halls 1 & 2), Wallisellenstrasse 49, 8050 Zurich'
    },
    datesText: {
      de: 'Täglich geöffnet: 25. September – 15. November 2026 | Flexibles Ticket (09:00 – 21:00 Uhr)',
      en: 'Open Daily: 25 September – 15 November 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      de: '15. November 2026',
      en: '15 November 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { deDay: 'OPEN PASS • JEDER TAG', enDay: 'OPEN PASS • ANY DATE', deDate: 'Gültig an jedem Tag bis 15. November 2026', enDate: 'Valid Any Day until 15 Nov 2026', deTag: 'Beliebteste Wahl • 100% Flexibel', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { deDay: 'WOCHENTAGS-TICKET (MO–FR)', enDay: 'WEEKDAY PASS (MON–FRI)', deDate: 'Gültig an jedem Werktag bis 15. November', enDate: 'Any Weekday until 15 Nov 2026', deTag: 'Ruhiger Besuch', enTag: 'Calm Visit' },
      'weekend-pass': { deDay: 'WOCHENENDE-TICKET (SA–SO)', enDay: 'WEEKEND PASS (SAT–SUN)', deDate: 'Gültig an jedem Wochenende bis 15. November', enDate: 'Any Weekend until 15 Nov 2026', deTag: 'Wochenend-Erlebnis', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      de: './images/dino_world_switzerland_banner_de.jpg',
      en: './images/dino_world_switzerland_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 38.00, price: 19.00 },
          kid: { standardPrice: 28.00, price: 14.00 }
        }
      }
    }
  },

  ee: {
    id: 'ee',
    name: 'Estonia',
    currencyCode: 'EUR',
    currencySymbol: { et: '€', en: '€' },
    phonePrefix: '+372',
    phonePlaceholder: '51234567',
    seatPrefix: 'EE',
    defaultLang: 'et',
    supportedLangs: ['et', 'en'],
    merchantName: 'Dino World Estonia',
    domainName: 'dynoworldee.live',
    venue: {
      et: 'Eesti Näituste Messikeskus (A- ja B-hall), Pirita tee 28, Tallinn',
      en: 'Estonian Fairs Centre (Halls A & B), Pirita tee 28, Tallinn'
    },
    datesText: {
      et: 'Avatud iga päev: 26. september – 8. november 2026 | Avatud pilet (09:00 – 21:00)',
      en: 'Open Daily: 26 September – 8 November 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      et: '8. november 2026',
      en: '8 November 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { etDay: 'AVATUD PILET • ÜKSKÕIK MIS PÄEV', enDay: 'OPEN PASS • ANY DATE', etDate: 'Kehtib igal päeval kuni 8. novembrini 2026', enDate: 'Valid Any Day until 8 Nov 2026', etTag: 'Populaarseim • 100% Paindlik', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { etDay: 'TÖÖPÄEVA PILET (E–R)', enDay: 'WEEKDAY PASS (MON–FRI)', etDate: 'Kehtib igal tööpäeval kuni 8. novembrini', enDate: 'Any Weekday until 8 Nov 2026', etTag: 'Rahulikum külastus', enTag: 'Calm Visit' },
      'weekend-pass': { etDay: 'NÄDALAVAHETUSE PILET (L–P)', enDay: 'WEEKEND PASS (SAT–SUN)', etDate: 'Kehtib igal nädalavahetusel kuni 8. novembrini', enDate: 'Any Weekend until 8 Nov 2026', etTag: 'Nädalavahetuse tippaeg', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      et: './images/dino_world_estonia_banner_et.jpg',
      en: './images/dino_world_estonia_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 24.00, price: 12.00 },
          kid: { standardPrice: 18.00, price: 9.00 }
        }
      }
    }
  },

  uk: {
    id: 'uk',
    name: 'United Kingdom',
    currencyCode: 'GBP',
    currencySymbol: { en: '£' },
    phonePrefix: '+44',
    phonePlaceholder: '7123456789',
    seatPrefix: 'UK',
    defaultLang: 'en',
    supportedLangs: ['en'],
    merchantName: 'Dino World UK',
    domainName: 'dynoworlduk.live',
    venue: {
      en: 'ExCeL London (Halls N1–N3), Royal Victoria Dock, 1 Western Gateway, London E16 1XL'
    },
    datesText: {
      en: 'Open Daily: 25 September – 15 November 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      en: '15 November 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { enDay: 'OPEN PASS • ANY DATE', enDate: 'Valid Any Day until 15 Nov 2026', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { enDay: 'WEEKDAY PASS (MON–FRI)', enDate: 'Any Weekday until 15 Nov 2026', enTag: 'Calm Visit • Off-Peak' },
      'weekend-pass': { enDay: 'WEEKEND PASS (SAT–SUN)', enDate: 'Any Weekend until 15 Nov 2026', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      en: './images/dino_world_uk_banner_en.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 25.00, price: 12.50 },
          kid: { standardPrice: 19.00, price: 9.50 }
        }
      }
    }
  },

  id: {
    id: 'id',
    name: 'Indonesia',
    currencyCode: 'IDR',
    currencySymbol: { id: 'Rp', en: 'Rp' },
    phonePrefix: '+62',
    phonePlaceholder: '81234567890',
    seatPrefix: 'ID',
    defaultLang: 'id',
    supportedLangs: ['id', 'en'],
    merchantName: 'Dino World Indonesia',
    domainName: 'dynoworldid.live',
    venue: {
      id: 'Arena JIEXPO Kemayoran (Hall B & C), Jakarta Pusat',
      en: 'Arena JIEXPO Kemayoran (Halls B & C), Central Jakarta'
    },
    datesText: {
      id: 'Buka Setiap Hari: 26 September – 15 November 2026 | Tiket Terbuka Bebas Pilih Hari (09:00 – 21:00 WIB)',
      en: 'Open Daily: 26 September – 15 November 2026 | Valid Any Day (09:00 AM – 09:00 PM)'
    },
    validUntilDate: {
      id: '15 November 2026',
      en: '15 November 2026'
    },
    isOpenPass: true,
    dates: {
      'any-day-pass': { idDay: 'TIKET FLEKSIBEL • BEBAS PILIH HARI', enDay: 'OPEN PASS • ANY DATE', idDate: 'Berlaku kapan saja hingga 15 November 2026', enDate: 'Valid Any Day until 15 Nov 2026', idTag: 'Paling Diminati • 100% Fleksibel', enTag: 'Best Value • 100% Flexible' },
      'weekday-pass': { idDay: 'TIKET HARI KERJA (SEN–JUM)', enDay: 'WEEKDAY PASS (MON–FRI)', idDate: 'Berlaku hari kerja hingga 15 November 2026', enDate: 'Any Weekday until 15 Nov 2026', idTag: 'Kunjungan Tenang', enTag: 'Calm Visit' },
      'weekend-pass': { idDay: 'TIKET AKHIR PEKAN (SAB–MIN)', enDay: 'WEEKEND PASS (SAT–SUN)', idDate: 'Berlaku akhir pekan hingga 15 November 2026', enDate: 'Any Weekend until 15 Nov 2026', idTag: 'Suasana Meriah', enTag: 'Weekend Prime' }
    },
    defaultDate: 'any-day-pass',
    banner: {
      id: './banner_jakarta.jpg',
      en: './banner_jakarta.jpg'
    },
    tiersConfig: {
      vip: {
        id: 'vip',
        color: '#fbc61c',
        popular: true,
        options: {
          adult: { standardPrice: 190000, price: 95000 },
          kid: { standardPrice: 130000, price: 65000 }
        }
      }
    }
  },

};

export const getCurrentGeo = () => {
  if (typeof window !== 'undefined' && window.DINO_GEO && GEOS[window.DINO_GEO.toLowerCase()]) {
    return window.DINO_GEO.toLowerCase();
  }

  if (typeof window !== 'undefined' && window.location) {
    const searchParams = new URLSearchParams(window.location.search);
    const geoParam = searchParams.get('geo') || searchParams.get('g');
    if (geoParam && GEOS[geoParam.toLowerCase()]) {
      const clean = geoParam.toLowerCase();
      localStorage.setItem('dino_geo', clean);
      return clean;
    }

    if (window.location.hash && window.location.hash.includes('?')) {
      const hashQuery = window.location.hash.split('?')[1];
      const hashParams = new URLSearchParams(hashQuery);
      const hashGeo = hashParams.get('geo') || hashParams.get('g');
      if (hashGeo && GEOS[hashGeo.toLowerCase()]) {
        const clean = hashGeo.toLowerCase();
        localStorage.setItem('dino_geo', clean);
        return clean;
      }
    }

    if (window.location.hostname) {
      const host = window.location.hostname.toLowerCase();
      if (host.includes('dynoworldsg') || host.includes('sgdynoworld') || host.includes('singapore')) return 'sg';
      if (host.includes('dynoworldmy') || host.includes('mydynoworld') || host.includes('malaysia')) return 'my';
      if (host.includes('dynoworldhk') || host.includes('hongkong')) return 'hk';
      if (host.includes('dynoworldkw') || host.includes('kuwait')) return 'kw';
      if (host.includes('dynoworldom') || host.includes('oman')) return 'om';
      if (host.includes('dynoworldqa') || host.includes('qatar')) return 'qa';
      if (host.includes('dynoworldlv') || host.includes('latvia')) return 'lv';
      if (host.includes('dynoworldpl') || host.includes('poland')) return 'pl';
      if (host.includes('dynoworldch') || host.includes('switzerland')) return 'ch';
      if (host.includes('dynoworldee') || host.includes('estonia')) return 'ee';
      if (host.includes('dynoworlduk') || host.includes('unitedkingdom')) return 'uk';
      if (host.includes('dynoworldid') || host.includes('indonesia')) return 'id';
    }

    const path = window.location.pathname.toLowerCase();
    if (path.includes('singapore') || path.includes('/sg')) return 'sg';
    if (path.includes('malaysia') || path.includes('/my')) return 'my';
    if (path.includes('oman') || path.includes('/om')) return 'om';
    if (path.includes('kuwait') || path.includes('/kw')) return 'kw';
    if (path.includes('hongkong') || path.includes('/hk')) return 'hk';
    if (path.includes('qatar') || path.includes('/qa')) return 'qa';
    if (path.includes('latvia') || path.includes('/lv')) return 'lv';
    if (path.includes('poland') || path.includes('/pl')) return 'pl';
    if (path.includes('switzerland') || path.includes('/ch')) return 'ch';
    if (path.includes('estonia') || path.includes('/ee')) return 'ee';
    if (path.includes('unitedkingdom') || path.includes('/uk')) return 'uk';
    if (path.includes('indonesia') || path.includes('/id')) return 'id';
  }

  if (typeof localStorage !== 'undefined') {
    const cached = localStorage.getItem('dino_geo');
    if (cached && GEOS[cached.toLowerCase()]) {
      return cached.toLowerCase();
    }
  }

  return 'qa';
};
